export default __webpack_public_path__ + "static/media/text_center.dd20e2fa.svg";